import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type ClaimRequest = {
  id: string;
  shelter_id: string;
  status: string;
  justification: string;
  contact_phone: string | null;
  admin_note: string | null;
  created_at: string;
  reviewed_at: string | null;
  shelter_name?: string;
  shelter_city?: string;
};

export const useClaimRequests = (userId: string | undefined) => {
  return useQuery({
    queryKey: ["claim-requests", userId],
    enabled: !!userId,
    queryFn: async (): Promise<ClaimRequest[]> => {
      const { data, error } = await supabase
        .from("shelter_claim_requests")
        .select("id, shelter_id, status, justification, contact_phone, admin_note, created_at, reviewed_at")
        .eq("user_id", userId!)
        .order("created_at", { ascending: false });
      if (error) throw error;
      const rows = data ?? [];
      if (rows.length === 0) return [];
      const ids = Array.from(new Set(rows.map((r) => r.shelter_id)));
      const { data: shelters } = await supabase
        .from("shelters")
        .select("id, name, city")
        .in("id", ids);
      const map = new Map((shelters ?? []).map((s) => [s.id, s]));
      return rows.map((r) => ({
        ...r,
        shelter_name: map.get(r.shelter_id)?.name,
        shelter_city: map.get(r.shelter_id)?.city,
      }));
    },
  });
};
